export const formatCallDuration = (
  value: number | null | undefined,
  unit: 'seconds' | 'minutes' = 'seconds'
): string => {
  if (value == null || !isFinite(value) || value < 0) return '0 sec';
  const totalSeconds = Math.round(unit === 'minutes' ? value * 60 : value);
  if (totalSeconds <= 0) return '0 sec';
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  if (h > 0) {
    if (m === 0) return `${h} hr`;
    return `${h} hr ${m} min`;
  }
  if (m === 0) return `${s} sec`;
  if (s === 0) return `${m} min`;
  return `${m} min ${s} sec`;
};

export const formatDurationFromSeconds = (value: number | null | undefined): string =>
  formatCallDuration(value, 'seconds');

export const formatDurationFromMinutes = (value: number | null | undefined): string =>
  formatCallDuration(value, 'minutes');
